import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FaCheck, FaTimes, FaMusic } from 'react-icons/fa';
import Select, { components } from 'react-select';

import { addSound } from '../../../redux/actions';
import Paths from 'paths';
import customStyles from 'consts/CustomStyles';

class SoundAdd extends Component{

    componentDidMount() {
        this.title.focus(); 
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.addSound(
            this.props.soundbox.id,
            {
                id: +this.id.value,
                characters: this.refs.characters.state.value ? this.refs.characters.state.value.map(char => char.value) : [],
                movie: this.refs.movie.state.value.value,
                title: this.title.value,
                titleFiltered: this.title.value,
                timing: this.timing.value,
                quote: this.quote.value,
                quoteFiltered: this.quote.value
            }
        );
        this.props.history.push(Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id));
    }

    cancel = (e) => {
        this.props.history.push(Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id));
    }

    render() {
        let characterList = [];
        for(let i=0; i<this.props.soundbox.characters.length; i++) {
            let character = this.props.soundbox.characters[i];
            characterList.push({ 
                value: character.id,
                label: character.id+": "+character.name
            });
        }

        let movieList = [];
        for(let i=0; i<this.props.soundbox.movies.length; i++) {
            let movie = this.props.soundbox.movies[i];
            movieList.push({ 
                value: movie.id,
                label: movie.id+": "+movie.title
            });
        }

        let nextSoundId = 1, lastSound;
        for(let i=0; i<this.props.soundbox.sounds.length; i++) {
            if(this.props.soundbox.sounds[i].id >= nextSoundId) { 
                nextSoundId = this.props.soundbox.sounds[i].id+1;
                lastSound = this.props.soundbox.sounds[i];
            }
        }

        return (
            <form onSubmit={(e) => this.handleSubmit(e)} className={'soundbox-grid-sound'}>
                <div className={'soundbox-grid-sound-id'}>
                    <input type="number" name="form-id" placeholder="ID" required defaultValue={nextSoundId} ref={input => this.id = input} />
                </div>
                <div className={'soundbox-grid-sound-characters'}> 
                    <Select 
                        ref={'characters'} 
                        isMulti
                        options={characterList} 
                        styles={customStyles.chars}
                        placeholder={'Chars'}
                        components={{ 
                            MultiValueLabel:({ ...props }) => { return (<components.MultiValueLabel {...props}>{props.data.value}</components.MultiValueLabel>)},
                            IndicatorsContainer:() => { return null }
                        }}>
                    </Select>
                </div>
                <div className={'soundbox-grid-sound-movie'}>
                    <Select 
                        ref={'movie'} 
                        options={movieList} 
                        defaultValue={lastSound ? movieList.find(movie => movie.value === lastSound.movie) : null}
                        styles={customStyles.movies}
                        placeholder={'Film'}
                        components={{ 
                            SingleValue:({ ...props }) => { return <components.SingleValue {...props}>{props.getValue()[0].value}</components.SingleValue>},
                            IndicatorsContainer:() => { return null }
                        }}>
                    </Select>
                </div>
                <div className={'soundbox-grid-sound-title'}>
                    <input type="text" name="form-title" placeholder="Titre" required ref={input => this.title = input} />
                </div>
                <div className={'soundbox-grid-sound-timing'}>
                    <input type="text" name="form-timing" placeholder="Temps" ref={input => this.timing = input} />
                </div>
                <div className={'soundbox-grid-sound-play'}><FaMusic/></div>
                <div className={'soundbox-grid-sound-quote'}>
                    <textarea ref={input => this.quote = input} placeholder="Réplique" defaultValue=""></textarea>
                </div>
                <button type="submit" className={'soundbox-grid-sound-save'}>
                    <FaCheck />
                </button>
                <div className={'soundbox-grid-sound-cancel'} onClick={this.cancel}>
                    <FaTimes />
                </div>
            </form>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addSound: (soundbox, item) => {
            dispatch(addSound(soundbox, item))
        }
    }
}

export default connect(null, mapDispatchToProps)(SoundAdd);